import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { getLocaleValue } from '../../../utils';

const customStyles = {
    option: (styles, {isSelected, isFocused}) => ({
        ...styles,
        color: isSelected ? '#fff' : isFocused ? '#fff' : '#333',
        opacity: isFocused ? 0.8 : 1,
        backgroundColor: isSelected ? '#121180' : isFocused ? '#121180' : '#fff'
    })
};

const Container = styled.div`
    display: ${props => props.inline ? 'flex' : ''};
    align-items: center;
    margin: 10px 0;
`;

const Label = styled.p`
    margin: ${props => props.inline ? '0 10px 0 0' : '0 10px 5px 0'};
    font-weight: 600;
    color: #121180;
`;

const DynamicContent = styled.p`
    color: #121180;
    margin: 4px 0 0 0;
    font-size: 14px;
    white-space: nowrap;
`;

const SelectContainer = styled.div`
    width: -webkit-fill-available;
    .css-yk16xz-control, .css-1pahdxg-control{
        border: 1px solid #121180;
        box-shadow: none;
        display: flex;
        flex-direction: ${props => props.isArabic ? 'row-reverse' : ''};
    }
    .css-g1d714-ValueContainer {
        justify-content: ${props => props.isArabic ? 'flex-end' : 'flex-start'};
    }
    .css-1ygshg6-option {
        display: flex;
        justify-content: ${props => props.isArabic ? 'flex-end' : 'flex-start'};
        background-color: #121180;
        color: #fff;
        cursor: default;
        padding: 8px 12px;
        width: 100%;
        user-select: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        box-sizing: border-box;
        opacity: 0.8;
    }
    :hover {
        .css-yk16xz-control{
            border: 1px solid #121180;
        }
    }
    :hover {
        .css-1pahdxg-control{
            border: 2px solid #121180 !important;
            box-shadow: none;
        }
    }
`;

const DropDown = ({isArabic, label, arabiclabel, onChange, value, inline, dynamic, required, options, disabled, placeholder, arabicplaceholder, editJob, error}) => {

    return(
        <Container inline={inline}>
            {label && <Label inline={inline} className={isArabic ? 'arabic' : ''} isArabic={isArabic}>{isArabic ? arabiclabel : label}{required && <span style={{color: 'red', margin: '0 2px'}}>*</span>}</Label>}
            <SelectContainer isArabic={isArabic}>
                {
                    value ? <Select isSearchable={false} value={value} isDisabled={disabled} styles={customStyles} placeholder={getLocaleValue(value)} name={label} options={options} onChange={(value) => onChange(value)} />  :
                    <Select isSearchable={false} value={value} isDisabled={disabled} styles={customStyles} placeholder={(placeholder && placeholder.length > 0) ? (placeholder) : `Select the ${label}`} name={label} options={options} onChange={(value) => onChange(value)} />              


                }
            </SelectContainer>
            {dynamic && <DynamicContent>Options will render dynamically</DynamicContent>}
            {error && <p className="text-danger m-0">{error}</p>}
        </Container>
    );
};

export default DropDown;